import ConnectExpertImage from '../../images/ConnectExpertImage.png'

function ConnectExpert() {
    return (
        <div style={{ marginLeft: '2.5px', marginRight: '20px', marginTop: '20px' }}>
            <img src={ConnectExpertImage} style={{ width: '100%', height: '' }} alt="" />
        </div>
    );
}

export default ConnectExpert;